/**
 * Paju 공통 코드 규칙
 *
 * 1. 코드는 대문자로 작성한다.
 * 2. 자릿수
 * - 현장: 4자리 (ex. S002)
 * - 시공구분: 2자리 (ex. TE)
 * - 동: 5자리 (ex. D0601)
 * - 층: 3자리 (ex. F01)
 * - 호실: 5자리 (ex. R0101)
 * - 구조물구분: 3자리 (ex. WL0)
 * - 숫자: 4자리 (ex. 0001)
 * 3. 모든 코드 구분자는 Underbar(_)로 구분한다.
 */

// export const baseUrl = 'https://ocs-compare-0206.s3.ap-northeast-2.amazonaws.com/DEV/mhnt';
export const baseUrl = 'https://vsc.safers.ai/api/s3/download';
// export const baseUrl = 'https://ocs-compare-0206.s3.ap-northeast-2.amazonaws.com/DEV/mhnt';
/**
 * 현장정보
 * 아래의 타입으로 현장정보를 나누어서 사용한다.
 *
 * site: 현장
 * siteKo: 현장 한글
 * siteType: 현장 타입
 */
export const siteInformation = [
  {
    site: 'bundang',
    siteKo: '느티마을 3단지 리모델링사업',
    siteBuildingCode: '309',
    siteBuildingName: '309동',
    siteType: 'S001',
    floorOrderJson: null,
    drawingUnits: 'cm',
    siteUrl: `${baseUrl}?directory=vsc/bundang&fileName=bundang.fbx`,
    thumbnail: `${baseUrl}?directory=vsc/bundang&fileName=bundang_thumbnail.png`,
    referencePoints: null,
    panorama: [
      {
        title: '분당 정자동 느티마을 3단지 리모델링 공사',
        url: 'https://my.matterport.com/show/?m=csTrZm6NoN6'
      }
    ],
    dwgFileList: [
      // {
      //   title: '분당_309동 평면도(철거)',
      //   url: '${baseUrl}?directory=vsc/bundang/drawing&fileName=bundang_D0309_floor_plan.dwg'
      // },
      // {
      //   title: '분당_309동 평면도(리모델링전)',
      //   url: '${baseUrl}?directory=vsc/bundang/drawing&fileName=bundang_D0309_floor_plan_before_remodeling.dwg'
      // },
      // {
      //   title: '분당_309동 평면도(리모델링후)',
      //   url: '${baseUrl}?directory=vsc/bundang/drawing&fileName=bundang_D0309_floor_plan_after_remodeling.dwg'
      // }
    ],
    pdfFileList: [
      {
        title: '분당_309동 평면도(철거)',
        thumbnail: `${baseUrl}?directory=vsc/bundang/drawing&fileName=bundang_D0309_floor_plan.png`,
        url: `${baseUrl}?directory=vsc/bundang/drawing&fileName=bundang_D0309_floor_plan.pdf`
      },
      {
        title: '분당_309동 평면도(리모델링전)',
        thumbnail: `${baseUrl}?directory=vsc/bundang/drawing&fileName=bundang_D0309_floor_plan_before_remodeling.png`,
        url: `${baseUrl}?directory=vsc/bundang/drawing&fileName=bundang_D0309_floor_plan_before_remodeling.pdf`
      },
      {
        title: '분당_309동 평면도(리모델링후)',
        thumbnail: `${baseUrl}?directory=vsc/bundang/drawing&fileName=bundang_D0309_floor_plan_after_remodeling.png`,
        url: `${baseUrl}?directory=vsc/bundang/drawing&fileName=bundang_D0309_floor_plan_after_remodeling.pdf`
      }
    ],
    cctvList: [
      {
        title: 'CCTV 1',
        url: 'http://119.65.216.155:1935/live/cctv01.stream_360p/playlist.m3u8\n'
      }
    ]
  },
  {
    site: 'paju',
    siteKo: '제일건설 파주 운정지구 A46BL 현장',
    siteBuildingCode: '604',
    siteBuildingName: '604동',
    siteType: 'S002',
    // siteUrl: `${baseUrl}/paju/paju.fbx?url`,
    floorOrderJson: null,
    drawingUnits: 'mm',
    siteUrl: `${baseUrl}?directory=vsc/paju&fileName=paju.fbx`,
    thumbnail: `${baseUrl}?directory=vsc/paju&fileName=paju_thumbnail.png`,
    referencePoints: null,
    panorama: [],
    dwgFileList: [
      // {
      //   title: '파주_101~106 단위세대 평면도',
      //   url: '${baseUrl}/paju/drawing/paju_101_106_unit_floor_plan.dwg'
      // }
    ],
    pdfFileList: [
      {
        title: '파주_101~106 단위세대 평면도(전체)',
        thumbnail: `${baseUrl}?directory=vsc/paju/drawing&fileName=paju_101_106_unit_floor_plan_color.png`,
        url: `${baseUrl}?directory=vsc/paju/drawing&fileName=paju_101_106_unit_floor_plan_color.pdf`
      },
      {
        title: '파주_101~106 단위세대 평면도(일부)',
        thumbnail: `${baseUrl}?directory=vsc/paju/drawing&fileName=paju_101_106_unit_floor_plan_partial.png`,
        url: `${baseUrl}?directory=vsc/paju/drawing&fileName=paju_101_106_unit_floor_plan_partial.pdf`
      }
    ],
    cctvList: [
      {
        title: 'CCTV 1',
        url: 'http://59.8.86.15:1935/live/51.stream/playlist.m3u8'
      }
    ]
  },
  {
    site: 'gonjiam',
    siteKo: '제일건설 곤지암역 A1-1BL 현장',
    siteBuildingCode: '107',
    siteBuildingName: '107동',
    siteType: 'S003',
    floorOrderJson: null,
    drawingUnits: 'm',
    siteUrl: `${baseUrl}?directory=vsc/gonjiam&fileName=gonjiam_APT.FBX`,
    thumbnail: `${baseUrl}?directory=vsc/gonjiam&fileName=gonjiam_thumbnail.png`,
    referencePoints: [
      { x: -7.884344, z: -173.149313, latitude: 37.353557, longitude: 127.340052 },
      { x: 355.281156, z: -173.149313, latitude: 37.35331, longitude: 127.344264 },
      { x: 355.281156, z: 57.048219, latitude: 37.351176, longitude: 127.344067 },
      { x: -7.884344, z: 57.048219, latitude: 37.351423, longitude: 127.339854 }
    ],
    panorama: [],
    dwgFileList: [],
    pdfFileList: [],
    cctvList: []
  },
  // {
  //   site: 'hyosung-factory',
  //   siteKo: '효성 공장',
  //   siteBuildingCode: '107',
  //   siteBuildingName: '107동',
  //   siteType: 'S004',
  //   floorOrderJson: null,
  //   drawingUnits: 'm',
  //   siteUrl: `${baseUrl}?directory=vsc/hyosung-factory&fileName=hyosung-factory.FBX`,
  //   thumbnail: `${baseUrl}?directory=vsc/gonjiam&fileName=gonjiam_thumbnail.png`,
  //   referencePoints: [
  //     { x: -99.324648, z: -232.895453, latitude: 35.221054, longitude: 128.658337 },
  //     { x: -99.314, z: 87.068, latitude: 35.218693, longitude: 128.656329 },
  //     { x: 220.675344, z: 87.104547, latitude: 35.217053, longitude: 128.659218 },
  //     { x: 220.675, z: -232.884, latitude: 35.219413, longitude: 128.661227 }
  //   ],
  //   panorama: [],
  //   dwgFileList: [],
  //   pdfFileList: [],
  //   cctvList: []
  // },
  {
    site: 'seogyodong',
    siteKo: '진흥기업(주) 홍대입구 임대주택 개발사업 신축공사',
    siteBuildingCode: '107',
    siteBuildingName: '107동',
    drawingUnits: 'm',
    siteType: 'S005',
    floorOrderJson: '/assets/floor-schema/seogyodong.json',
    siteUrl: `${baseUrl}?directory=vsc/seogyodong&fileName=seogyodong.FBX`,
    thumbnail: `${baseUrl}?directory=vsc/seogyodong&fileName=seogyodong_thumbnail.png`,
    referencePoints: [
      { x: -84.671, z: -63.197, latitude: 37.553184, longitude: 126.918373 },
      { x: 86.498, z: -63.227, latitude: 37.554263, longitude: 126.919798 },
      { x: 86.648, z: 73.093, latitude: 37.553364, longitude: 126.920883 },
      { x: -84.642, z: 73.093, latitude: 37.552284, longitude: 126.919458 }
    ],
    panorama: [],
    dwgFileList: [],
    pdfFileList: [],
    cctvList: []
  }
];

/**
 * 구분정보
 * 아래의 타입으로 구분정보를 나누어서 사용한다.
 * classification: 구분
 * classificationKo: 구분 한글
 * classificationType: 구분 타입
 */
export const classificationInformation = [
  {
    classification: 'temporaryMember',
    classificationKo: '가설부재',
    classificationType: 'TE'
  },
  { classification: 'existingMember', classificationKo: '존치부재', classificationType: 'EX' },
  {
    classification: 'demolitionMember',
    classificationKo: '철거부재',
    classificationType: 'DE'
  },
  {
    classification: 'additionalConstruction',
    classificationKo: '추가시공',
    classificationType: 'AD'
  },
  {
    classification: 'basicTreatment',
    classificationKo: '기본치와종',
    classificationType: 'BA'
  },
  {
    classification: 'spaceInformation',
    classificationKo: '공간정보',
    classificationType: 'RM'
  },
  {
    classification: 'groundSiteInformation',
    classificationKo: '지상정보',
    classificationType: 'GR'
  }
];

/**
 * 호실정보
 * 아래의 타입으로 호실정보를 나누어서 사용한다.
 * roomType: 호실 타입
 * roomName: 호실 이름
 * roomNameKo: 호실 한글 이름
 *
 * 추가되는 호실은 아래의 규칙에 맞추어서 추가되어야 한다.
 */
export const roomInformation = [
  { roomType: 'R00', roomName: 'commonArea', roomNameKo: '공용' },
  ...Array.from({ length: 20 }, (_, i) => {
    const roomNumber = i + 1;
    const roomType = roomNumber < 10 ? `R0${roomNumber}` : `R${roomNumber}`;

    return {
      roomType: roomType,
      roomName: `room_${roomNumber}`,
      roomNameKo: `${roomNumber}호실`
    };
  })
];

/**
 * 층정보
 * 아래의 타입으로 층정보를 나누어서 사용한다.
 * floorType: 층 타입
 * floor: 층 이름
 * floorKo: 층 한글 이름
 */
export const floorInformation = [
  { floorType: 'F01', floor: 'floor_1', floorKo: '1층' },
  { floorType: 'F02', floor: 'floor_2', floorKo: '2층' },
  { floorType: 'F03', floor: 'floor_3', floorKo: '3층' },
  { floorType: 'F04', floor: 'floor_4', floorKo: '4층' },
  { floorType: 'F05', floor: 'floor_5', floorKo: '5층' },
  { floorType: 'F06', floor: 'floor_6', floorKo: '6층' },
  { floorType: 'F07', floor: 'floor_7', floorKo: '7층' },
  { floorType: 'F08', floor: 'floor_8', floorKo: '8층' },
  { floorType: 'F09', floor: 'floor_9', floorKo: '9층' },
  { floorType: 'F10', floor: 'floor_10', floorKo: '10층' },
  { floorType: 'F11', floor: 'floor_11', floorKo: '11층' },
  { floorType: 'F12', floor: 'floor_12', floorKo: '12층' },
  { floorType: 'F13', floor: 'floor_13', floorKo: '13층' },
  { floorType: 'F14', floor: 'floor_14', floorKo: '14층' },
  { floorType: 'F15', floor: 'floor_15', floorKo: '15층' },
  { floorType: 'F16', floor: 'floor_16', floorKo: '16층' },
  { floorType: 'B01', floor: 'floor_1_basement', floorKo: '지하1층' },
  { floorType: 'B02', floor: 'floor_2_basement', floorKo: '지하2층' },
  { floorType: 'B03', floor: 'floor_3_basement', floorKo: '지하3층' },
  {
    floorType: 'B00',
    floor: 'independentFoundationLevel',
    floorKo: '독립기초체취고'
  },
  { floorType: 'BRF', floor: 'basementRoofFloor', floorKo: '지하지붕층' },
  { floorType: 'PHR', floor: 'penthouseRoof', floorKo: '옥상층' }
];

/**
 * 구조물 정보
 * 아래의 타입으로 구조물 정보를 나누어서 사용한다.
 * structureType: 구조물 타입
 * structureName: 구조물 이름
 * structureNameKo: 구조물 한글 이름
 */
export const structuralElementClassification = [
  /** S001 - Ver. Bundang */
  { structureType: 'WL', structureName: 'wall', structureNameKo: '벽' },
  { structureType: 'SL', structureName: 'slab', structureNameKo: 'Slab' },
  { structureType: 'ST', structureName: 'stairs', structureNameKo: '계단' },
  { structureType: 'RF', structureName: 'roof', structureNameKo: '지붕' },
  { structureType: 'BM', structureName: 'beam', structureNameKo: 'Beam' },
  { structureType: 'CL', structureName: 'column', structureNameKo: '기둥' },
  {
    structureType: 'CB',
    structureName: 'columnBeam',
    structureNameKo: '기둥형Beam'
  },
  {
    structureType: 'EP',
    structureName: 'steelPipe',
    structureNameKo: '철재 파이프'
  },
  { structureType: 'PL', structureName: 'pile', structureNameKo: '말뚝' },
  {
    structureType: 'SC',
    structureName: 'scaffolding',
    structureNameKo: '비계'
  },
  {
    structureType: 'OWL',
    structureName: 'outerWall',
    structureNameKo: '외벽'
  },

  /** S002 - Ver. Paju */
  {
    structureType: 'WL0',
    structureName: 'wall',
    structureNameKo: '벽'
  },
  { structureType: 'SL0', structureName: 'slab', structureNameKo: '바닥' },
  { structureType: 'SL1', structureName: 'slab', structureNameKo: '천장' },
  { structureType: 'ST0', structureName: 'stairs', structureNameKo: '계단' },
  { structureType: 'RF0', structureName: 'roof', structureNameKo: '지붕' },
  { structureType: 'BM0', structureName: 'beam', structureNameKo: 'Beam' },
  { structureType: 'CL0', structureName: 'column', structureNameKo: '기둥' },
  {
    structureType: 'CB0',
    structureName: 'columnBeam',
    structureNameKo: '기둥형Beam'
  },
  {
    structureType: 'EP0',
    structureName: 'steelPipe',
    structureNameKo: '철재 파이프'
  },
  { structureType: 'PL0', structureName: 'pile', structureNameKo: '말뚝' },
  {
    structureType: 'SC0',
    structureName: 'scaffolding',
    structureNameKo: '비계'
  },
  { structureType: 'DOR', structureName: 'door', structureNameKo: '출입문' },
  { structureType: 'WD0', structureName: 'window', structureNameKo: '창문' },
  { structureType: 'T01', structureName: 't01', structureNameKo: '위험구역' },
  { structureType: 'T02', structureName: 't02', structureNameKo: '판넬' },
  { structureType: 'T03', structureName: 't03', structureNameKo: '가벽' }
];

/**
 * 공간구분(RM)정보
 * 아래의 타입으로 구조물 정보를 나누어서 사용한다.
 *
 * structureType: 구조물 타입
 * structureName: 구조물 이름
 * structureNameKo: 구조물 한글 이름
 */
export const roomTypeClassification = [
  /** S001 - Ver. Bundang */
  // { structureType: 'ADR1', structureName: 'adRoom', structureNameKo: 'AD실' },
  // { structureType: 'ADR2', structureName: 'adRoom', structureNameKo: 'AD실' },
  // { structureType: 'ETC1', structureName: 'etc', structureNameKo: 'ETC' },
  // { structureType: 'PDR1', structureName: 'pd', structureNameKo: 'PD' },
  // { structureType: 'PDR2', structureName: 'pd', structureNameKo: 'PD' },
  // { structureType: 'PDR3', structureName: 'pd', structureNameKo: 'PD' },
  { structureType: 'LIR1', structureName: 'livingRoom', structureNameKo: '거실' },
  {
    structureType: 'MTR1',
    structureName: 'multiPurposeRoom',
    structureNameKo: '다용도실'
  },
  {
    structureType: 'MTR2',
    structureName: 'multiPurposeRoom',
    structureNameKo: '다용도실'
  },
  { structureType: 'BAL1', structureName: 'balcony', structureNameKo: '발코니' },
  { structureType: 'BAL2', structureName: 'balcony', structureNameKo: '발코니' },
  { structureType: 'BAL3', structureName: 'balcony', structureNameKo: '발코니' },
  { structureType: 'BTR1', structureName: 'bathroom', structureNameKo: '욕실' },
  { structureType: 'BED1', structureName: 'bedroom1', structureNameKo: '침실1' },
  { structureType: 'BED2', structureName: 'bedroom2', structureNameKo: '침실2' },
  { structureType: 'BED3', structureName: 'bedroom3', structureNameKo: '침실3' },
  { structureType: 'FDR1', structureName: 'entrance', structureNameKo: '현관' },
  { structureType: 'STW1', structureName: 'stairway', structureNameKo: '계단실' },
  { structureType: 'HAL1', structureName: 'hallway', structureNameKo: '복도' },
  { structureType: 'HAL2', structureName: 'hallway', structureNameKo: '복도' },
  {
    structureType: 'EVR1',
    structureName: 'elevatorRoom',
    structureNameKo: '엘리베이터실'
  },

  /** S001 - Bundang Ver.2.0 */
  {
    structureType: 'EP',
    structureName: 'ElementProxy',
    structureNameKo: 'ElementProxy',
    type: 'B-2-0'
  },
  { structureType: 'SC', structureName: 'Scaffold', structureNameKo: '비계', type: 'B-2-0' },
  { structureType: 'SL', structureName: 'Slab', structureNameKo: 'Slab', type: 'B-2-0' },
  { structureType: 'ST', structureName: 'Stair', structureNameKo: '계단', type: 'B-2-0' },
  { structureType: 'WL', structureName: 'Wall', structureNameKo: '벽', type: 'B-2-0' },
  { structureType: 'RF', structureName: 'RF0', structureNameKo: '지붕', type: 'B-2-0' },
  { structureType: 'CL', structureName: 'Col', structureNameKo: '기둥', type: 'B-2-0' },
  { structureType: 'SITE', structureName: 'SITE', structureNameKo: '지상정보', type: 'B-2-0' },
  { structureType: 'SE', structureName: 'SE', structureNameKo: '지상정보', type: 'B-2-0' },
  { structureType: 'BRFSL', structureName: 'BRFSL', structureNameKo: '지붕 Slab', type: 'B-2-0' },
  { structureType: 'BRFWL', structureName: 'BRFWL', structureNameKo: '지붕 벽', type: 'B-2-0' },

  /** S002 - Ver. Paju */
  // { structureType: 'ADR', structureName: 'adRoom', structureNameKo: 'AD실' },
  // { structureType: 'ETC', structureName: 'etc', structureNameKo: 'ETC' },
  // { structureType: 'PDR', structureName: 'pd', structureNameKo: 'PD' },
  { structureType: 'LIR', structureName: 'livingRoom', structureNameKo: '거실' },
  {
    structureType: 'MTR',
    structureName: 'multiPurposeRoom',
    structureNameKo: '다용도실'
  },
  { structureType: 'BAL', structureName: 'balcony', structureNameKo: '발코니' },
  { structureType: 'BTR', structureName: 'bathroom', structureNameKo: '욕실' },
  { structureType: 'BED', structureName: 'bedroom', structureNameKo: '침실' },
  { structureType: 'FDR', structureName: 'entrance', structureNameKo: '현관' },
  { structureType: 'STW', structureName: 'stairway', structureNameKo: '계단실' },
  { structureType: 'HAL', structureName: 'hallway', structureNameKo: '복도' },
  {
    structureType: 'EVR',
    structureName: 'elevatorRoom',
    structureNameKo: '엘리베이터실'
  },
  {
    structureType: 'ABR',
    structureName: 'separatedRoom',
    structureNameKo: '구별된공간'
  },
  {
    structureType: 'AL1',
    structureName: 'vehicleEntryLine',
    structureNameKo: '차량진입라인'
  },
  {
    structureType: 'AL2',
    structureName: 'parkingArea',
    structureNameKo: '주차구역'
  },
  {
    structureType: 'AL3',
    structureName: 'unspecified',
    structureNameKo: '주차구역'
  },
  {
    structureType: 'SIT',
    structureName: 'specificSite',
    structureNameKo: '특정Site'
  },
  {
    structureType: 'Ex_wall',
    structureName: 'Ex_wall',
    structureNameKo: '외벽체'
  },
  {
    structureType: 'In_wall',
    structureName: 'In_wall',
    structureNameKo: '내벽체'
  }
];
